import {useState} from 'react';
import styled from 'styled-components';
import RightNav from './RightNav';
import {CiMenuFries} from "react-icons/ci";
import {IoCloseOutline} from "react-icons/io5";

const StyledBurger = styled.div`
    position: relative;
  //position: ${({open}) => open ? 'fixed' : 'absolute'};
  //top: ${({open}) => open ? '16px' : '4px'};
  //right: 20px;
  z-index: ${({open}) => open ? '99999' : '500'};
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;

/*  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({open}) => open ? '#ccc' : '#F29727'};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({open}) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    &:nth-child(2) {
      transform: ${({open}) => open ? 'translateX(100%)' : 'translateX(0)'};
      opacity: ${({open}) => open ? 0 : 1};
    }

    &:nth-child(3) {
      transform: ${({open}) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }*/
`;

const MenuShadow = styled.div`
    background: rgba( 255, 255, 255, 0.05 );
    backdrop-filter: blur( 10px );
    border-radius: 10px;
    opacity: 0.6;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    top: -17px;
    position: ${({open}) => open ? 'absolute' : 'relative'};
    display: ${({open}) => open ? 'block' : 'none'};
`;

const Burger = ({logo}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen((prevState) => !prevState);
    }

    return (
        <>
            <StyledBurger className="menu-icon" open={isOpen} onClick={() => toggleMenu()}>
                {/*<div/>*/}
                {/*<div/>*/}
                {/*<div/>*/}
                {isOpen ? <IoCloseOutline size={32}/>  : <CiMenuFries size={36} className='menu-icon-open'/> }
            </StyledBurger>

            <RightNav
                open={isOpen}
                logo={logo}
                toggle={toggleMenu}
            />

            <MenuShadow open={isOpen} onClick={toggleMenu}/>
        </>
    )
}

export default Burger;
